export class VariantsAvailability {
  constructor(variantId, data) {
    this.variantId = variantId
    this.data = data
  }

  availability() {
    // eslint-disable-next-line max-len
    return this.data?.find(variant => Number(variant?.node?.legacyResourceId) === Number(this.variantId))
  }

  inventoryLevels() {
    return this.availability()?.node?.inventoryItem?.inventoryLevels?.edges?.map(
      variantInventoryLevel => variantInventoryLevel?.node,
    )
  }

  offlineInventoryLevels() {
    // eslint-disable-next-line max-len
    return this.inventoryLevels()?.filter(inventoryLevel => inventoryLevel?.location?.isActive && !inventoryLevel?.location?.fulfillsOnlineOrders && !inventoryLevel?.location?.name.includes('draft'))
  }

  availableStoresFromLocations() {
    return this.offlineInventoryLevels()?.map(inventoryLevel => {

      const quantityAvailable = inventoryLevel?.quantities?.find(quantity => quantity?.name === 'available')?.quantity

      let message = ''

      const {
        notAvailable,
        limitedAvailability,
        available,
      } = window.cnvs.strings.product.store_availability

      if (quantityAvailable === 0) {
        message = `${notAvailable} ${inventoryLevel?.location?.name}`
      } else if (quantityAvailable === 1) {
        message = `${limitedAvailability} ${inventoryLevel?.location?.name}`
      } else if (quantityAvailable > 1) {
        message = `${available} ${inventoryLevel?.location?.name}`
      }

      return {

        /* TO-DO: format message */
        /*
          0 = Not available
          1-2 = Limited availability
          3 and up = Available
        */
        message,
        countryCode: inventoryLevel?.location?.address?.countryCode,
        address: inventoryLevel?.location?.address,
        quantities: inventoryLevel?.quantities,
        quantityAvailable,
      }
    })
  }

  availableStoresFromLocationsSortedByProximity(latitude, longitude) {
    if (!latitude || !longitude) {
      return this.availableStoresFromLocations()
    }

    return this.availableStoresFromLocations()?.map(store => {
      // eslint-disable-next-line max-len
      store.distance = this.calculateDistance(latitude, longitude, store?.address?.latitude, store?.address?.longitude)

      return store
    }).sort((a, b) => a?.distance - b?.distance)
  }

  /*
  availableStoresByCity(city) {
    if (!city) {
      return this.availableStoresFromLocations()
    }

    return this.availableStoresFromLocations()?
      .filter(store => store?.address?.city === city)
  }
  */

  /*
  // Returns array of all cities
  cities () {
    return this.availableStoresFromLocations()?
      .map(store => store?.address?.city)
  }
  */

  calculateDistance(latitudeFrom, longitudeFrom, latitudeTo, longitudeTo) {
    if ((latitudeFrom === latitudeTo) && (longitudeFrom === longitudeTo)) {
      return 0
    }

    const radialLatitudeFrom = Math.PI * latitudeFrom / 180
    const radialLatitudeTo = Math.PI * latitudeTo / 180
    const fromMinusTo = longitudeFrom - longitudeTo
    const radialFromMinusTo = Math.PI * fromMinusTo / 180
    // eslint-disable-next-line max-len, no-mixed-operators
    let distance = Math.sin(radialLatitudeFrom) * Math.sin(radialLatitudeTo) + Math.cos(radialLatitudeFrom) * Math.cos(radialLatitudeTo) * Math.cos(radialFromMinusTo)

    if (distance > 1) {
      distance = 1
    }

    distance = Math.acos(distance)
    distance = distance * 180 / Math.PI
    distance = distance * 60 * 1.1515

    return distance
  }
}
